import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useLanguage } from "../contexts/LanguageContext";
import type { ReactNode } from "react";

interface PreloaderProps {
  children: ReactNode;
}

export function Preloader({ children }: PreloaderProps) {
  const { loading } = useAuth();
  const { t } = useLanguage();

  // Show loading screen while auth is being initialized
  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 gradient-mesh flex items-center justify-center">
        <div className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="bg-gradient-to-br from-primary to-primary-dark p-4 rounded-2xl shadow-lg">
              <Loader2 className="w-8 h-8 text-white animate-spin" />
            </div>
          </div>
          <p className="text-slate-600 font-medium">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  // Once auth is loaded, render the app
  return <>{children}</>;
}

